import { Box, Circle, Image, Link, Text, Tooltip } from "@chakra-ui/react";
import { Link as CourseDetailsLink } from "react-router-dom";
import { ReactComponent as Calendar } from '../../svg/calendar.svg'
import { ReactComponent as Certificate } from '../../svg/certificate.svg'
import { ReactComponent as Heart } from '../../svg/empty-heart.svg'
import { ReactComponent as WhiteHeart } from '../../svg/heart-full.svg'
import { ReactComponent as Beginner } from '../../svg/beginner.svg'
import { ReactComponent as Intermediate } from '../../svg/intermediate.svg'
import { ReactComponent as Advanced } from '../../svg/advanced.svg'
import { useDispatch, useSelector } from "react-redux";
import { handleFavourite } from "../../redux/api/apiCalls";

export default function IndividualCourseCard({ id, title, image, date, level, certificate, favourite }) {
    const favouriteIsLoading = useSelector(state => state.coursesState.favouriteIsLoading)
    const dispatch = useDispatch()

    const favouriteHandler = () => {
        dispatch(handleFavourite(id))
    }

    const getIcon = (level) => {
        switch (level) {
            case 'Beginner':
                return <Beginner width='18px' height='18px' fill='#fa5953' />
            case 'Intermediate':
                return <Intermediate width='18px' height='18px' fill='#fa5953' />
            case 'Advanced':
                return <Advanced width='18px' height='18px' fill='#fa5953' />
            default:
                return <Beginner width='18px' height='18px' fill='#fa5953' />
        }
    }

    return (
        <Link as={CourseDetailsLink} to={`/courses/${id}`} width={['95%', '95%', '47%', '30%', '23%']} style={{ textDecoration: 'none' }} >
            <Box
                d='flex'
                flexDir='column'
                width='100%'
                borderRadius='30px'
                bg='#ffffff'
                boxShadow='md'
                position='relative'
                cursor='pointer'
            >
                <Image
                    src={image ? image : './images/unavailable-image.jpg'}
                    alt={title}
                    borderRadius='30px'
                    width='100%'
                    height='180px'
                    objectFit='cover'
                />
                <Box width='100%' p='1.5rem'>
                    <Tooltip
                        label={title}
                        fontSize='20px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='400'
                        color='#ffffff'
                        bg='#333333'
                        hasArrow
                    >
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize='18px'
                            fontWeight='700'
                            color='#333333'
                            mb='1rem'
                            textTransform='capitalize'
                            whiteSpace='nowrap'
                            overflow='hidden'
                            textOverflow='ellipsis'
                        >
                            {title}
                        </Text>
                    </Tooltip>
                    <Box
                        d='flex'
                        justifyContent='center'
                        alignItems='flex-start'
                        flexDir='column'
                        style={{ fontFamily: 'Mulish, sans-serif', gap: '1rem' }}
                        fontSize='14px'
                        fontWeight='600'
                        color='#666666'
                    >
                        <Box d='flex' justifyContent='center' alignItems='center'>
                            <Calendar width='18px' height='18px' />
                            <Text ml='2'>{date}</Text>
                        </Box>
                        <Box d='flex' justifyContent='center' alignItems='center'>
                            <Certificate width='18px' height='18px' />
                            <Text ml='2'>Certificate</Text>
                        </Box>
                        <Box d='flex' justifyContent='center' alignItems='center'>
                            {getIcon(level)}
                            <Text ml='2'>{level ? level : `N/A`}</Text>
                        </Box>
                    </Box>
                </Box>
                <Circle
                    size='45px'
                    position='absolute'
                    top='10px'
                    right='10px'
                    boxShadow='0px 3px 4px rgba(0, 0, 0, 0.15), 0px 8px 16px rgba(0, 0, 0, 0.15)'
                    bg='#0000004D'
                    pointerEvents = {favouriteIsLoading ? 'none':'all'}
                    onClick={(e) => {
                        e.preventDefault()
                        favouriteHandler()
                    }}
                    cursor='pointer'
                    zIndex='5'
                >
                    {
                        favourite === 'Yes' ?
                            <WhiteHeart /> :
                            <Heart />
                    }
                </Circle>
            </Box>
        </Link>
    )
}